export default __webpack_public_path__ + "static/media/AndrewFire_crop.8c52da02.jpg";